// Generated with Packemon: https://packemon.dev
// Platform: node, Support: stable, Format: lib
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var parse5 = require('parse5');
var adapter = require('parse5/lib/tree-adapters/default');
var parseStyle = require('style-parser');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var adapter__default = /*#__PURE__*/_interopDefaultLegacy(adapter);
var parseStyle__default = /*#__PURE__*/_interopDefaultLegacy(parseStyle);
/* eslint-disable @typescript-eslint/prefer-ts-expect-error, @typescript-eslint/no-unsafe-assignment */

function patchTextNodeInChildren(parentNode) {
  parentNode.childNodes.forEach(node => {
    if (node.nodeName === '#text' && !node.textContent) {
      Object.defineProperties(node, {
        nodeType: {
          value: 3
        },
        textContent: {
          value: node.value,
          writable: true
        },
        value: {
          get() {
            return this.textContent;
          },
          set(value) {
            this.textContent = value;
          }
        }
      });
    }
  });
}
function createStyleDeclaration(decls) {
  const object = parseStyle__default['default'](decls);
  const style = Object.keys(object);
  Object.assign(style, object);
  return style;
}
const treeAdapter = {
  ...adapter__default['default'],
  createCommentNode(data) {
    return {
      ...adapter__default['default'].createCommentNode(data),
      nodeType: 8
    };
  },
  createElement(tagName, namespace, attrs) {
    let attributes = [...attrs];
    const element = {
      ...adapter__default['default'].createElement(tagName, namespace, attrs),
      attributes,
      getAttribute(name) {
        const result = attributes.find(attr => attr.name === name);
        return result ? result.value : null;
      },
      hasAttribute(name) {
        return attributes.some(attr => attr.name === name);
      },
      nodeType: 1,
      protocol: '',
      removeAttribute(name) {
        attributes = attributes.filter(attr => attr.name !== name);
      },
      setAttribute(name, value) {
        const result = attributes.find(attr => attr.name === name);
        if (result) {
          result.value = value;
        } else {
          attributes.push({
            name,
            value
          });
        }
      },
      style: [],
      tagName,
      textContent: ''
    };
    const style = element.getAttribute('style');
    if (style) {
      element.style = createStyleDeclaration(style);
    }
    if (element.nodeName === 'a') {
      element.protocol = ':';
    }
    return element;
  },
  insertText(parentNode, text) {
    adapter__default['default'].insertText(parentNode, text);
    patchTextNodeInChildren(parentNode);
  },
  insertTextBefore(parentNode, text, referenceNode) {
    adapter__default['default'].insertTextBefore(parentNode, text, referenceNode);
    patchTextNodeInChildren(parentNode);
  }
};
function parseHTML(markup) {
  return parse5.parse(markup, {
    treeAdapter
  });
}
function createHTMLDocument() {
  const doc = parseHTML('<!DOCTYPE html><html><head></head><body></body></html>');
  const html = doc.childNodes[1];
  const body = html.childNodes[1];
  Object.defineProperty(html, 'body', {
    value: body
  });
  Object.defineProperty(body, 'innerHTML', {
    set(value) {
      // #document -> html -> body -> tag
      // @ts-expect-error
      this.childNodes = parseHTML(String(value)).childNodes[0].childNodes[1].childNodes;
    }
  });
  return html;
}
function polyfill() {
  global.INTERWEAVE_SSR_POLYFILL = createHTMLDocument;
}
function polyfillDOMImplementation() {
  if (typeof document === 'undefined') {
    // @ts-ignore
    global.document = {};
  }
  if (typeof document.implementation === 'undefined') {
    // @ts-ignore
    global.document.implementation = {};
  }
  if (typeof document.implementation.createHTMLDocument !== 'function') {
    // @ts-ignore
    global.document.implementation.createHTMLDocument = createHTMLDocument;
  }
}
exports.polyfill = polyfill;
exports.polyfillDOMImplementation = polyfillDOMImplementation;